import request from '@/utils/request'
interface MetaHomeSetting {
  cartoonUrl: string
  figureUrl: string
  floors: string
  lamp: string
  mirror: string
  ornaments: string
  plant: string
  roomUrl: string
  sofa: string
  sports: string
  tables: string
  television: string
  userId: string
  version: string
  wallpaper: string
  window: string
  body:string
  suit?:string
  scenery?:string
  festivalGift?:string
  festivalDecor?:string
  hasSetting?:boolean
  has3DFigure?:boolean
}
interface saveMetaHomeSettingList {
  wallpaper?: string
  floors?: string
  sofa?: string
  window?: string
  television?: string
  plant?: string
  ornaments?: string
  sports?: string
  tables?: string
  lamp?: string
  mirror?: string
  roomUrl?: string
  body?: string
  suit?: string
  figureUrl?: string
  festivalGift?:string
  festivalDecor?:string
}
interface MetaItemList {
  [key: string]: Record<string, any>[]
}
export function getMetaHomeSetting() {
  return request<MetaHomeSetting>({
    url: '/v1/api/news/metaHome/getMetaHomeSetting',
    method: 'post'
  })
}
export function getMetaItemList() {
  return request<MetaItemList>({
    url: '/v1/api/news/metaHome/metaItemList',
    method: 'post'
  })
}
export function myHomeuploadImg(data: FormData) {
  return request<MetaItemList | string>({
    url: '/v1/api/news/metaHome/user/uploadBase64Img',
    method: 'post',
    data
  })
}
export function saveMetaHomeSetting(data: saveMetaHomeSettingList) {
  return request<MetaItemList>({
    url: '/v1/api/news/metaHome/saveMetaHomeSetting',
    method: 'post',
    data
  })
}
export function beginGuidePopup(str:string) {
  return request<boolean>({
    url: '/v1/api/news/metaHome/beginGuidePopup',
    method: 'get',
    params:{function:str}
  })
}
export function calculateFigureUrl(params:Record<string, any>) {
  return request<MetaItemList|string>({
    url: '/v1/api/news/metaHome/calculateFigureUrl',
    method: 'get',
    params
  })
}
///v1/api/news/metaHome/none/festivalEndMills
export function festivalEndMills(){
    return request({
        url:'/v1/api/news/metaHome/none/festivalEndMills',
        method:'post'
    })
}

